
import * as types from '../types';

const isWaiting = (
    state = {},
    action,
) => {
  switch (action.type) {
  case types.LOGIN_REQUEST:
  case types.REGISTRATION_REQUEST:
  case types.LOGOUT_REQUEST:
  case types.PASSWORD_EMAIL_REQUEST:
  case types.PASSWORD_RESET_REQUEST:
  case types.EXERCISE_REQUEST:
  case types.EXERCISE_CREATE_REQUEST:
  case types.EXERCISE_UPDATE_REQUEST:
  case types.EXERCISE_DELETE_REQUEST:
  case types.HISTORY_REPORT_REQUEST:
  case types.CHANGE_SETTINGS_REQUEST:
  case types.CHANGE_PASSWORD_REQUEST:
  case types.VALIDATE_TOKEN_REQUEST:
  case types.VALIDATE_EMAIL_REQUEST:
  case types.GROUP_REQUEST:
  case types.GROUP_UPDATE_REQUEST:
  case types.GROUP_TOKEN_REFRESH_REQUEST:
  case types.GROUP_USERS_REQUEST:
  case types.GROUP_USER_UPDATE_REQUEST:
  case types.GROUP_USER_REMOVE_REQUEST:
  case types.GROUP_SEND_INVITATION_REQUEST:
    {
      const newState = { ...state };
      const actionGroup = action.type.replace('_REQUEST', '');
      newState[actionGroup] = true;
      return { ...newState };
    }
  case types.LOGIN_SUCCESS:
  case types.REGISTRATION_SUCCESS:
  case types.LOGOUT_SUCCESS:
  case types.PASSWORD_EMAIL_SUCCESS:
  case types.PASSWORD_RESET_SUCCESS:
  case types.EXERCISE_SUCCESS:
  case types.EXERCISE_CREATE_SUCCESS:
  case types.EXERCISE_UPDATE_SUCCESS:
  case types.EXERCISE_DELETE_SUCCESS:
  case types.HISTORY_REPORT_SUCCESS:
  case types.CHANGE_SETTINGS_SUCCESS:
  case types.CHANGE_PASSWORD_SUCCESS:
  case types.VALIDATE_TOKEN_SUCCESS:
  case types.VALIDATE_EMAIL_SUCCESS:
  case types.GROUP_SUCCESS:
  case types.GROUP_UPDATE_SUCCESS:
  case types.GROUP_TOKEN_REFRESH_SUCCESS:
  case types.GROUP_USERS_SUCCESS:
  case types.GROUP_USER_UPDATE_SUCCESS:
  case types.GROUP_USER_REMOVE_SUCCESS:
  case types.GROUP_SEND_INVITATION_SUCCESS:
    {
      const newSuccessState = { ...state };
      const actionGroupSuccess = action.type.replace('_SUCCESS', '');
      newSuccessState[actionGroupSuccess] = false;
      return { ...newSuccessState };
    }
  case types.LOGIN_FAILURE:
  case types.REGISTRATION_FAILURE:
  case types.LOGOUT_FAILURE:
  case types.PASSWORD_EMAIL_FAILURE:
  case types.PASSWORD_RESET_FAILURE:
  case types.EXERCISE_FAILURE:
  case types.EXERCISE_CREATE_FAILURE:
  case types.EXERCISE_UPDATE_FAILURE:
  case types.EXERCISE_DELETE_FAILURE:
  case types.HISTORY_REPORT_FAILURE:
  case types.CHANGE_SETTINGS_FAILURE:
  case types.CHANGE_PASSWORD_FAILURE:
  case types.VALIDATE_TOKEN_FAILURE:
  case types.VALIDATE_EMAIL_FAILURE:
  case types.GROUP_FAILURE:
  case types.GROUP_UPDATE_FAILURE:
  case types.GROUP_TOKEN_REFRESH_FAILURE:
  case types.GROUP_USERS_FAILURE:
  case types.GROUP_USER_UPDATE_FAILURE:
  case types.GROUP_USER_REMOVE_FAILURE:
  case types.GROUP_SEND_INVITATION_FAILURE:
    {
      const newFailureState = { ...state };
      const actionGroupFailure = action.type.replace('_FAILURE', '');
      newFailureState[actionGroupFailure] = false;
      return { ...newFailureState };
    }
  default:
    return state;
  }
};

export default isWaiting;



// WEBPACK FOOTER //
// ./src/reducers/network.js